export default __webpack_public_path__ + "static/media/3111.a0eb3617.jpg";